<template> 
  <stats-card data-background-color="green" :key="componentKey" height="100px">
    <template slot="header">
      <strong>{{title}}</strong>
    </template>

    <template slot="content">
      <!-- <p class="category">{{dataList[0]}}/{{dataList[1]}} Gigabytes</p> -->
      <MapChart
        :countryData="dataList"
        highColor="#ff0000"
        lowColor="#aaaaaa"
        countryStrokeColor="#909090"
        defaultCountryFillColor="#dadada"
        LangUser="en"
      />
    </template>

    <template slot="footer">
      <div class="stats">
        <md-icon>date_range</md-icon>
        Last updated at: {{updated_at}}
      </div>
    </template>
  </stats-card>

</template>

<style>
  #map-svg {
    max-height: 500px;
  }
</style>

<script>
  import MapChart from 'vue-chart-map';
  import { StatsCard } from "@/components";

  export default {
    name: 'WorldMapChart',
    props: ['title', 'updated_at', 'dataList'],
    components: {
      StatsCard,
      MapChart
    },
    data() {
      return {
        componentKey: 0
      }
    },
    watch: {
      updated_at: function() {
        this.componentKey += 1;
      }
    }
  };
</script>
